import { NLandingPage } from './about-us.model';
import { IImageCarouselItem } from '../../../../share/components/image-carousel/image-carousel.model';

const PREFIX = 'ABOUT_US';

export const INFORMATION_CARDS: NLandingPage.IInformationCards[] = [
  {
    label: `${PREFIX}.FEATURES.CONVENIENCE`,
    color: 'text-[#38BCE0]',
  },
  {
    label: `${PREFIX}.FEATURES.SECURITY`,
    color: 'text-[#01426A]',
  },
  {
    label: `${PREFIX}.FEATURES.FLEXIBILITY`,
    color: 'text-[#15FABC]',
  },
];

export const SUBSCRIPTIONS: NLandingPage.ISubsciptions[] = [
  {
    label: `${PREFIX}.PACKAGES.MONTHLY`,
    bgColor: 'white',
    color: 'shrl-blue-500',
    priceColor: 'shrl-cyan-500',
  },
  {
    label: `${PREFIX}.PACKAGES.QUARTELY`,
    bgColor: 'shrl-teal-500',
    color: 'shrl-blue-500',
  },
  {
    label: `${PREFIX}.PACKAGES.YEARLY`,
    bgColor: 'shrl-blue-500',
    color: 'white',
    priceColor: 'shrl-teal-500',
  },
];

export const CAROUSEL_ITEMS: IImageCarouselItem[] = [
  {
    imageSrc: '/assets/images/apartment_1.png',
    imageAlt: {
      translationKey: `${PREFIX}.GUESTS_TESTIMONIALS.CAROUSEL.ITEM_1.IMAGE_ALT`,
    },
    description: {
      translationKey: `${PREFIX}.GUESTS_TESTIMONIALS.CAROUSEL.ITEM_1.DESCRIPTION`,
    },
    linkUrl: 'https://www.booking.com/hotel/pl/lovely-apartment-lodz.html',
    linkLabel: {
      translationKey: `${PREFIX}.GUESTS_TESTIMONIALS.CAROUSEL.ITEM_1.LINK_LABEL`,
    },
    buttonPosition: 'below',
  },
  {
    imageSrc: '/assets/images/apartment_2.jpg',
    imageAlt: {
      translationKey: `${PREFIX}.GUESTS_TESTIMONIALS.CAROUSEL.ITEM_2.IMAGE_ALT`,
    },
    description: {
      translationKey: `${PREFIX}.GUESTS_TESTIMONIALS.CAROUSEL.ITEM_2.DESCRIPTION`,
    },
    linkUrl: 'https://www.booking.com/Share-ud1956',
    linkLabel: {
      translationKey: `${PREFIX}.GUESTS_TESTIMONIALS.CAROUSEL.ITEM_2.LINK_LABEL`,
    },
    buttonPosition: 'below',
  },
  {
    imageSrc: '/assets/images/apartment_3.jpg',
    imageAlt: {
      translationKey: `${PREFIX}.GUESTS_TESTIMONIALS.CAROUSEL.ITEM_3.IMAGE_ALT`,
    },
    description: {
      translationKey: `${PREFIX}.GUESTS_TESTIMONIALS.CAROUSEL.ITEM_3.DESCRIPTION`,
    },
    linkUrl: 'https://www.booking.com/Share-TSLGLIn',
    linkLabel: {
      translationKey: `${PREFIX}.GUESTS_TESTIMONIALS.CAROUSEL.ITEM_3.LINK_LABEL`,
    },
    buttonPosition: 'below',
  },
  {
    imageSrc: '/assets/images/apartment_4.jpg',
    imageAlt: {
      translationKey: `${PREFIX}.GUESTS_TESTIMONIALS.CAROUSEL.ITEM_4.IMAGE_ALT`,
    },
    description: {
      translationKey: `${PREFIX}.GUESTS_TESTIMONIALS.CAROUSEL.ITEM_4.DESCRIPTION`,
    },
    linkUrl: 'https://www.booking.com/Share-u1Io79f',
    linkLabel: {
      translationKey: `${PREFIX}.GUESTS_TESTIMONIALS.CAROUSEL.ITEM_4.LINK_LABEL`,
    },
    buttonPosition: 'below',
  },
  {
    imageSrc: '/assets/images/apartment_5.jpg',
    imageAlt: {
      translationKey: `${PREFIX}.GUESTS_TESTIMONIALS.CAROUSEL.ITEM_5.IMAGE_ALT`,
    },
    description: {
      translationKey: `${PREFIX}.GUESTS_TESTIMONIALS.CAROUSEL.ITEM_5.DESCRIPTION`,
    },
    linkUrl: 'https://www.booking.com/Share-uQnJCd8',
    linkLabel: {
      translationKey: `${PREFIX}.GUESTS_TESTIMONIALS.CAROUSEL.ITEM_5.LINK_LABEL`,
    },
    buttonPosition: 'below',
  },
  {
    imageSrc: '/assets/images/apartment_6.jpg',
    imageAlt: {
      translationKey: `${PREFIX}.GUESTS_TESTIMONIALS.CAROUSEL.ITEM_6.IMAGE_ALT`,
    },
    description: {
      translationKey: `${PREFIX}.GUESTS_TESTIMONIALS.CAROUSEL.ITEM_6.DESCRIPTION`,
    },
    linkUrl: 'https://www.booking.com/Share-M6SNI99',
    linkLabel: {
      translationKey: `${PREFIX}.GUESTS_TESTIMONIALS.CAROUSEL.ITEM_6.LINK_LABEL`,
    },
    buttonPosition: 'below',
  },
  {
    imageSrc: '/assets/images/apartment_7.jpg',
    imageAlt: {
      translationKey: `${PREFIX}.GUESTS_TESTIMONIALS.CAROUSEL.ITEM_7.IMAGE_ALT`,
    },
    description: {
      translationKey: `${PREFIX}.GUESTS_TESTIMONIALS.CAROUSEL.ITEM_7.DESCRIPTION`,
    },
    linkUrl: 'https://www.booking.com/Share-i2b4ZPp',
    linkLabel: {
      translationKey: `${PREFIX}.GUESTS_TESTIMONIALS.CAROUSEL.ITEM_7.LINK_LABEL`,
    },
    buttonPosition: 'below',
  },
];
